import React from 'react'
import './common-title.css'

const Common_title = ({headingText, spanText, ...props}) => {
    return (
        <>
            <section className="heading_holder">
                <h4>{headingText} <span>{spanText}</span></h4>
            </section>
        </>
    )
}

export default Common_title